import { render, staticRenderFns } from "./roleManageList_back.vue?vue&type=template&id=5eca8a62&"
import script from "./roleManageList_back.vue?vue&type=script&lang=js&"
export * from "./roleManageList_back.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports